import * as React from 'react'
import VendorUserContactCard from 'vendors/components/vendorContact/VendorUserContactCard'
import VendorGeneralContactCard from 'vendors/components/vendorContact/VendorGeneralContactCard'
import VendorContactCardsSkeleton from 'vendors/components/vendorContact/VendorContactCardsSkeleton'
import Box from '@mui/material/Box'

type VendorContactCardsProps = {
  onVendorContactEdit: (userId: string) => void
  onVendorGeneralContactEdit: (generalContactId: string) => void
  handleOpenDeleteUserContactDialog: (contactId: string, contactEmail: string) => void
  handleOpenDeleteGeneralContactDialog: (contactId: string, contactEmail: string) => void
  vendorId: string
  contacts: VendorContactsResponseType | undefined
  isContactsLoading: boolean
}

const VendorContactCards: React.FC<VendorContactCardsProps> = ({
  vendorId,
  onVendorContactEdit,
  handleOpenDeleteUserContactDialog,
  onVendorGeneralContactEdit,
  handleOpenDeleteGeneralContactDialog,
  contacts,
  isContactsLoading
}) => {
  const handleEditClick = (userId: string) => {
    onVendorContactEdit(userId)
  }

  const handleGeneralEditClick = (generalContactId: string) => {
    onVendorGeneralContactEdit(generalContactId)
  }

  const handleUserDeleteClick = (contactId: string, contactEmail: string) => {
    handleOpenDeleteUserContactDialog(contactId, contactEmail)
  }

  const handleGeneralDeleteClick = (contactId: string, contactEmail: string) => {
    handleOpenDeleteGeneralContactDialog(contactId, contactEmail)
  }

  if (isContactsLoading) {
    return (
      <Box display="grid" gridTemplateColumns="1fr" gap={2} sx={{ mt: 2, justifyItems: 'center' }}>
        <VendorContactCardsSkeleton />
        <VendorContactCardsSkeleton />
      </Box>
    )
  }

  return (
    <>
      <Box display="grid" gridTemplateColumns="1fr" gap={2} sx={{ mt: 2, justifyItems: 'center' }}>
        {contacts?.generalContacts.map((contact) => (
          <VendorGeneralContactCard
            contact={contact}
            onEdit={handleGeneralEditClick}
            onDelete={handleGeneralDeleteClick}
            key={contact.id}
            vendorId={vendorId}
          />
        ))}
        {contacts?.userContacts.map((contact) => (
          <VendorUserContactCard
            contact={contact}
            onEdit={handleEditClick}
            onDelete={handleUserDeleteClick}
            key={contact.id}
            vendorId={vendorId}
            isDeleteDisabled={contacts.userContacts.length < 2}
          />
        ))}
      </Box>
    </>
  )
}

export default VendorContactCards
